import React from 'react'
import { Link, Outlet } from 'react-router-dom'
import NewsNavbar from './NewsNavbar'

const NewNews = () => {
  return (
    <>
      {/* <NewsNavbar/>
         */}
      <div className='lg:w-[70rem] m-auto '>
        <NewsNavbar />
        <div className='mt-10'>
          <Outlet />
        </div>
      </div>
    </>

  )
}

export default NewNews